module.exports = __webpack_public_path__ + "img/artist4.5262ffaa.jpeg";